<section class="job-apply-hero">
  <div class="container">
    <div>
      <div class="breadcrumbs">
        <a [routerLink]="getLocalizedRoute('/')">{{ 'breadcrumbs.home' | transloco }}</a>
        <i class="fas fa-chevron-right"></i>
        <a [routerLink]="getLocalizedRoute('/job/' + job?.id)">{{ 'breadcrumbs.jobDetail' | transloco }}</a>
        <i class="fas fa-chevron-right"></i>
        <span>{{ 'breadcrumbs.apply' | transloco }}</span>
      </div>
      <h1 class="job-apply-hero__title">{{ job?.title }}</h1>
      <div class="job-apply-hero__company">
        <img [src]="job?.tenantLogoUrl" [alt]="job?.tenantName" />
        <span>{{ job?.tenantName }}</span>
      </div>
    </div>

    <!-- Match Score (only for logged-in users when coming from recommended jobs) -->
    <div class="job-apply-hero__match" *ngIf="matchScore !== null && isLoggedIn">
      <div class="match-content">
        <span class="match-label">{{ 'pages.jobs.recommendedJobs.matchScore' | transloco }}</span>
        <div class="match-score-value" [ngClass]="matchScore | matchScoreClass">{{ matchScore | matchScoreNormalized }}%</div>
      </div>
      <div class="match-progress">
        <div class="match-progress-bar" [style.width.%]="matchScore | matchScoreNormalized" [ngClass]="matchScore | matchScoreClass"></div>
      </div>
    </div>
  </div>
</section>
